import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { storage } from '@/utils/storage';

// Base API URL - bạn sẽ thay đổi theo backend của mình
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.phuongdongstore.tech';

// Tạo axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor - Tự động thêm token vào header
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = storage.getAccessToken();
    const skipsBearerToken = ['/auth/login', '/auth/introspect', '/auth/refresh']
      .some((endpoint) => config.url?.includes(endpoint));
    if (token && !skipsBearerToken && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

export default apiClient;
